import { useLocalObservable } from 'mobx-react-lite';

import { CallAccessFormProps } from './CallAccessForm.types';

interface ICallAccessFormPresenter {
  isWaitingRoomEnabled: boolean;
  isGuestsAllowed: boolean;
  switchGuestsAllowed(): void;
  switchWaitingRoomEnabled(): void;
}

export function useCallAccessFormPresenter(props: CallAccessFormProps): ICallAccessFormPresenter {
  const presenter = useLocalObservable<ICallAccessFormPresenter>(() => ({
    get isWaitingRoomEnabled(): boolean {
      return props.call.waitingRoom.enabled;
    },
    get isGuestsAllowed(): boolean {
      return props.call.isGuestsAllowed;
    },

    switchGuestsAllowed(): void {
      props.call.setGuestsAllowed(!props.call.isGuestsAllowed);
    },

    switchWaitingRoomEnabled(): void {
      props.call.waitingRoom.setEnabled(!props.call.waitingRoom.enabled);
    },
  }));

  return presenter;
}
